import requester from 'utils/requester';
import api from 'config/api';
import { CONTENT_TYPES } from 'constants/content-types';
import { IRequesterResponse, ChannelType } from './loader-types';

type VTVPageParams = { offset?: number; all?: boolean };

export const TVPageLoader = async ({ offset, all }: VTVPageParams) => {
  const $offset = Number.isInteger(offset) ? offset : 0;

  const contentType = CONTENT_TYPES.TV_SERIES;
  const { data: content } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}`,
    params: {
      'type[eq]': 'channel',
      $expand: 'resources(url),entitlement,favorite,bookmark,genres',
      $orderby: 'lcn',
      $limit: all ? null : 24,
      $offset,
    },
  })) as IRequesterResponse<ChannelType[]>;

  return { content, contentType, offset: $offset };
};
export default TVPageLoader;
